import { Link, type LinkProps } from 'react-router';

interface CustomLinkProps extends Omit<LinkProps, 'to'> {
  linkable?: boolean;
  to?: LinkProps['to'] | undefined;
}

export default function Linkable({ linkable = true, children, to, className, ...restProps }: CustomLinkProps) {
  return linkable && to ? (
    <Link
      className={className}
      to={to}
      {...restProps}>
      {children}
    </Link>
  ) : (
    <div className={className}>{children}</div>
  );
}
